import useAppUrlOpenListener from '~/src/hooks/app/useAppUrlOpenListener'
import useAppBackButtonListener from '~/src/hooks/app/useAppBackButtonListener'

const useAppListeners = (): void => {
  useAppUrlOpenListener()
  useAppBackButtonListener()
}

export default useAppListeners
